module.exports = __webpack_public_path__ + "img/heavy_tank_factory_small.0bf72d89.png";